import Vue from "vue";
import GlobalTooltip from "@global/global-elements/global-tooltip/global-tooltip.vue";

const tooltip = {
    init: () => {
        const tooltips = document.querySelectorAll('.global-tooltip-wrapper');
        tooltips.forEach(tooltip => {
            new Vue({
                render: h => h(GlobalTooltip, {
                    props: {
                        htmlContent: tooltip.querySelector('.global-tooltip-wrapper__content').innerHTML
                    }
                }),
            }).$mount(tooltip);
        });
    },
    registerGlobalListener: () => {
        document.addEventListener('click', function(e) {
            window.dispatchEvent(new CustomEvent('tooltip-open', { detail: { target: e.target }}))
        });
    }
}

export { tooltip }
